import { gql } from "@apollo/client";

export const ARCHIVE_MESSAGES_FOR_ORDER = gql`
  mutation ArchiveMessagesForOrder(
    $data: ChatUpdateManyMutationInput!
    $where: ChatWhereInput!
  ) {
    archiveMessagesForOrder(data: $data, where: $where)
  }
`;

export const SEND_MESSAGE = gql`
  mutation SendMessage(
    $args: ChatCreateInput!
    $supplier: String!
    $olderChatRead: Boolean!
  ) {
    sendMessage(
      args: $args
      supplier: $supplier
      olderChatRead: $olderChatRead
    ) {
      id
      createdAt
      orderId
      message
    }
  }
`;
